/* eslint-disable */

export default {
  install (Vue, options) {
    let analytics = {}
    analytics.isCreated = false

    analytics.getGA = () => {
      if (gtag) {
        analytics.isCreated = true
        analytics.ga = gtag
      }
    }

    analytics.send = (eventAction, eventCategory, eventLabel, eventValue) => {
      if (eventAction === void 0 || eventCategory === void 0 || eventAction === void 0) {
        console.warn('eventCategory and eventAction needs to be defined')
        return
      }

      if (!analytics.isCreated) {
        analytics.getGA()

        setTimeout(() => {
          analytics.send( ...arguments )
        }, 100)
        return
      }

      if (eventValue === void 0) {
        // analytics.ga('send', 'event', eventCategory, eventAction)
        analytics.ga('event', eventAction, {
          'event_category': eventCategory,
          'event_label': eventLabel
        })
      } else {
        // analytics.ga('send', 'event', eventCategory, eventAction, eventValue)

        analytics.ga('event', eventAction, {
          'event_category': eventCategory,
          'event_label': eventLabel,
          'value': eventValue
        })
      }
    }

    analytics.page = (page) => {
      if (!analytics.isCreated) {
        analytics.getGA()

        setTimeout(() => {
          analytics.page(page)
        }, 100)
        return
      }

      analytics.ga('send', 'pageview', page)
    }

    Vue.prototype.$ga = analytics
  }
}
